var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngryFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione-monotone",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#555555",
    stroke: "#555555",
    strokeWidth: 1.28,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 2C15.432 2 2 15.432 2 32s13.432 30 30 30s30-13.432 30-30S48.568 2 32 2zm0 57.5C16.836 59.5 4.5 47.164 4.5 32S16.836 4.5 32 4.5c15.163 0 27.5 12.336 27.5 27.5S47.163 59.5 32 59.5z",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 41.834c-4.538 0-8.082 3.058-9.837 6.492c-.47.918.155 1.912.849 1.339c5.758-4.771 12.184-4.8 17.977 0c.693.573 1.318-.421.848-1.339c-1.755-3.434-5.298-6.492-9.837-6.492",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.799 30.699a.536.536 0 0 0 .043-.246a31.154 31.154 0 0 1 3.262 2.863c-.203-1.885-1.125-3.654-2.365-5.115c-1.25-1.461-2.852-2.641-4.596-3.441a13.653 13.653 0 0 0-5.59-1.279c-1.914-.008-3.801.42-5.387 1.455c1.531.148 2.885.359 4.212.665a.533.533 0 0 0-.138.175a5.825 5.825 0 1 0 10.559 4.923",
    fill: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.447 23.48c-1.92.018-3.84.469-5.59 1.279c-1.744.801-3.346 1.98-4.596 3.441c-1.24 1.461-2.162 3.23-2.365 5.115a31.039 31.039 0 0 1 3.262-2.863a.536.536 0 0 0 .043.246a5.824 5.824 0 1 0 10.558-4.924a.544.544 0 0 0-.138-.175a32.291 32.291 0 0 1 4.212-.665c-1.585-1.034-3.472-1.461-5.386-1.454",
    fill: "#555555"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngryFace);
export default __webpack_public_path__ + "static/media/angry-face.32cb9eb1061ecbc74262f01825f6afbb.svg";
export { ForwardRef as ReactComponent };